import { WidgetTab } from '@pages/AdditionalServices/containers/widgetTabsContext';
import { useEffect, useState } from 'react';

import { getTabSectionId, isCustomsPaymentsRootDirectory } from './helpers';

/**
 * Разделы таможенных платежей среди вкладок виджета
 */
export const useCustomsPaymentsSectionIds = (tabs: WidgetTab[]) => {
  const [customsSectionIds, setCustomsSectionIds] = useState<string[]>([]);

  const serviceSectionIds = tabs
    .filter((tab) => tab.type === 'service' && !!tab.data?.id)
    .map((tab) => getTabSectionId(tab));

  const serviceSectionIdsKey = serviceSectionIds.join(',');

  useEffect(() => {
    let isActual = true;

    Promise.all(
      serviceSectionIds.map((sectionId) =>
        isCustomsPaymentsRootDirectory(sectionId).then((isCustoms) => (isCustoms ? sectionId : null))
      )
    ).then((sectionIds) => {
      isActual && setCustomsSectionIds(sectionIds.filter((sectionId) => !!sectionId));
    });

    return () => {
      isActual = false;
    };
  }, [serviceSectionIdsKey]);

  return customsSectionIds;
};
